import { render, staticRenderFns } from "./no_legal_lawyer_index.vue?vue&type=template&id=404ad810&scoped=true"
import script from "./no_legal_lawyer_index.vue?vue&type=script&lang=js"
export * from "./no_legal_lawyer_index.vue?vue&type=script&lang=js"
import style0 from "./no_legal_lawyer_index.vue?vue&type=style&index=0&id=404ad810&prod&scoped=true&lang=less"
import style1 from "./no_legal_lawyer_index.vue?vue&type=style&index=1&id=404ad810&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404ad810",
  null
  
)

export default component.exports